<template>
    <div id="secure">
        <!-- START NAV -->
        <TopMenu />
        <!-- END NAV -->
        <div class="container">
            <div class="columns">
                <div class="column is-12">
                    <nav class="breadcrumb" aria-label="breadcrumbs">
                        <ul>
                            <li>
                                <a v-on:click="goHome()">Super Admin</a>
                            </li>
                            <li class="is-active">
                                <a href="#" aria-current="page">Items</a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            
            <div class="columns">
                <div class="column is-12">
                    <section class="info-tiles">
                        <div class="card is-hidden1">
                            <div class="card-header" style="padding: 10px;">
                                <a class="button is-small is-info" v-on:click="goSchoolTypes()" style="margin-left: 10px;">Manage School Types</a>&nbsp;&nbsp;or 
                                <a class="button is-small is-warning" v-on:click="goManageCategories()" style="margin-left: 10px;">Manage Categories</a>
                                <loading
                                    :active.sync="isLoading1"
                                    :can-cancel="false"
                                    :is-full-page="false">
                                </loading>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        
            <div class="columns">
                <div class="column is-12">
                    <div class="card is-hidden1">
                        <div class="card-header">
                            <p class="card-header-title">Items</p>
                            <a class="button is-primary" v-on:click="addItemForm()" style="margin: 5px;" v-show="!addItem">Add An Item</a>
                            <a class="button is-warning" v-on:click="closeAddItemForm()" style="margin: 5px" v-show="addItem">Close Add Item</a>
                        </div>
                        <div class="card-content">
                            <b-message title="Guide: Behavior type" type="is-success" aria-close-label="Close message" class="notification-tutorial">
                                a) Normal (General use such as Help teachers, consult supervisor, clean class/office etc)<br/>
                                b) Attendance (Daily Attendance. Max 1x daily. Usually used when users clock in schools/office). View monthly attendance from Home > Attendance > Class, choose month, view monthly attendance.<Br/>
                                c) Subject attendance (Attendance for each subject class or meetings. No max daily scan. View monthly attendance from Home> Attendance > Class, choose month, view monthly attendance> Choose list of class from top right panel.<br/>
                                d) Parents (Help parents, obey parents, do homework, sleep early etc). Submitted by parents/students via Parents app. Parent login from their ID submitted to the system. It can be ID, phone number or email
                            </b-message>                        
                            <div class="content" v-show="addItem">
                                <item-add></item-add>
                            </div>
                            <loading :active.sync="isLoading2" 
                                :can-cancel="false" 
                                :is-full-page="true">
                            </loading>
                            <item-list v-bind:dataList="dataList"></item-list>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import TopMenu from "./TopMenu";
import ItemList from './ItemList';
import ItemAdd from './ItemAdd';
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    name: "SuperItems",
    components: {
        TopMenu,
        Loading,
        ItemList,
        ItemAdd
    },
    data() {
        return {
            superId: "",
            superEmail: "",
            isLoading1: false,
            isLoading2: false,
            listTemplate: [],
            dataList: [],
            selectTemplate: "-1",
            addItem: false,
        };
    },
    created() {
        this.superId = localStorage.getItem("superId");
        this.superEmail = localStorage.getItem("superEmail");
        this.getItems();
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    mounted() {},
    methods: {
        addItemForm(){
            this.addItem = true;
        },
        closeAddItemForm(){
            this.addItem = false;
        },
        getItems() {
            let self = this;
            self.isLoading2 = true;

            self.dataList = []

            axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
            axios.defaults.responseType = "json";
            axios.post(process.env.MY_URL + "/super/item/list", {
                superEmail: localStorage.getItem("superEmail")
            })
            .then(response => {
                if (response.data.success == true) {
                    self.dataList = response.data.listItem

                    if (self.dataList){
                        for (var i = 0; i < self.dataList.length; i++){
                            var tempCategory = self.dataList[i].categories[0]
                            self.dataList[i].categories = ""
                            self.dataList[i].categories = tempCategory
                        }
                    }
                } else {
                    Toast.open({
                        message: e.response.data.msg,
                        type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    });
                }
                self.isLoading2 = false;
            })
            .catch(e => {
                console.log(e.response);
                if (e.response.status == 400) {
                    Toast.open({
                        message: e.response.data.msg,
                        type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    });
                } else {
                    Toast.open({
                        message:
                            "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                        type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    });
                }
                self.isLoading2 = false;
            });
        },
        goHome() {
            this.$router.push({
                name: "SuperHome"
            });
        },
        goSchoolTypes() {
            this.$router.push({
                name: "SuperSchoolTypes"
            });
        },
        goManageCategories() {
            this.$router.push({
                name: "SuperCategories"
            });
        }
    }
};
</script>

<style scoped>
html,
body {
    font-size: 16px;
    line-height: 1.5;
    height: 100%;
    background: #ecf0f3;
}
nav.navbar {
    border-top: 4px solid #276cda;
    margin-bottom: 1rem;
}
.navbar-item.brand-text {
    font-weight: 300;
}
.navbar-item,
.navbar-link {
    font-size: 14px;
    font-weight: 700;
}
.columns {
    width: 100%;
    height: 100%;
    margin-left: 0;
}
.menu-label {
    color: #8f99a3;
    letter-spacing: 1.3;
    font-weight: 700;
}
.menu-list a {
    color: #0f1d38;
    font-size: 14px;
    font-weight: 700;
}
.menu-list a:hover {
    background-color: transparent;
    color: #276cda;
}
.menu-list a.is-active {
    background-color: transparent;
    color: #276cda;
    font-weight: 700;
}
.card {
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
    margin-bottom: 2rem;
}
.card-header-title {
    color: #8f99a3;
    font-weight: 400;
}
.info-tiles {
    margin: 1rem 0;
}
.info-tiles .subtitle {
    font-weight: 300;
    color: #8f99a3;
}
.hero.welcome.is-info {
    background: #36d1dc;
    background: -webkit-linear-gradient(to right, #5b86e5, #36d1dc);
    background: linear-gradient(to right, #5b86e5, #36d1dc);
}
.hero.welcome .title,
.hero.welcome .subtitle {
    color: hsl(192, 17%, 99%);
}
.card .content {
    font-size: 14px;
}
.card-footer-item {
    font-size: 14px;
    font-weight: 700;
    color: #8f99a3;
}
.card-table .table {
    margin-bottom: 0;
}
.events-card .card-table {
    max-height: 250px;
    overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Super/Items.vue